/**
 * Lista vinda do WS (contacts_list) costuma ser parcial. Fazer spread sobre o estado anterior
 * evita perder responsibleName/assignedTo/tagId quando esses campos não vêm no payload.
 */
export function mergeContactsList<T extends { id: number }>(prev: T[], incoming: Array<Partial<T> & { id: number }>): T[] {
  const map = new Map(prev.map(c => [Number(c.id), c]));
  return incoming.map(row => {
    const id = Number(row.id);
    const p = map.get(id);
    if (!p) return row as T;
    return { ...p, ...row } as T;
  });
}
